import { DiamondInfoItem} from "./DiamondInfoItem";

export default DiamondInfoItem;
